import api from "../../api/api.js"

const state = {
  token: window.localStorage.getItem('token'),
  username: window.localStorage.getItem('username'),
  admin: window.localStorage.getItem('admin'),
  staff: window.localStorage.getItem('staff'),
  error: null
};


const getters = {
// Check if token exists or not
  isLoggedIn: state => !!state.token || !!state.username,
  getUsername: state => state.username,
  getToken: state => state.token,
  getAdmin: state => state.admin,
  getStaff: state => state.staff,
  getError: state => state.error,
};


const actions = {
  async getUserInfo({ commit }) {
    const response = await api.userInfo();
    if (response["email"] || response["username"]) {
      const username = response["email"] || response["username"];
      window.localStorage.setItem('username', username);
      const admin = response["admin"];
      window.localStorage.setItem('admin', admin);
      const staff = response["staff"];
      window.localStorage.setItem('staff', staff);
    }
    else {
      commit('setUsername', null);
      commit('setAdmin', null);
      commit('setStaff', null);
      window.localStorage.setItem('admin', null);
      window.localStorage.setItem('username', null);
      window.localStorage.setItem('staff', null);
    }

  },
};


const mutations = {
// Update user
  setUsername: (state, username) => {
    state.username = username
  },
  setAdmin: (state, admin) => {
    state.admin = admin
  },
  setStaff: (state, staff) => {
    state.staff = staff
  }
};


export default {
  state,
  getters,
  actions,
  mutations
}